  var trengoInitialised = false;

  // Set up the Trengo widget key
  window.Trengo = window.Trengo || {};
  window.Trengo.key = 'MOUbr1MPudZwdenv7Ms0';

  // Callback when Trengo is ready
  window.Trengo.on_ready = function () {
    trengoInitialised = true;
  };

  // Function to open the Trengo modal
  function OpenTrengoModal() {
    if (trengoInitialised) {
      window.Trengo.Api.Widget.open('email'); // Ensure 'email' is the correct channel
    } else {
      console.warn("Trengo is not initialized yet.");
    }
  }

  // Dynamically load the Trengo script
  (function () {
    var scriptLoaded = false;
    var nTimer = setInterval(function () {
      if (window.jQuery) {
        jQuery(document).ready(function () {
          if (!scriptLoaded) {
            scriptLoaded = true;

            // Load the Trengo widget script
            setTimeout(function () {
              (function (d, script) {
                script = d.createElement('script');
                script.defer = true;
                script.src = 'https://cdn.widget.trengo.eu/embed.js';
                d.getElementsByTagName('head')[0].appendChild(script);
              })(document);
            }, 3000);

            // Attach click event to open the modal
            jQuery('.trigger-trengo').on('click', function (event) {
              event.preventDefault();
              OpenTrengoModal();
            });
          }
        });
        clearInterval(nTimer);
      }
    }, 100);
  })();